import { useState } from "react";
import { useNavigate } from "react-router-dom/dist";
import ExamInfo from "../../components/home/ExamInfo";
import Notification from "../notification/Notification";

const Banner = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handlescroll = () => {
    window.scrollTo({
      top: 600,
      behavior: 'smooth'
    });
  };

  const handleBellIconClick = () => {
    setIsPopupOpen(true);
  };

  const handleCloseExamInfo = () => {
    setIsPopupOpen(false);
  };

  return (
    <div className="mx-auto relative md:mb-16">
      <div className="relative max-md:flex max-md:flex-col max-md:justify-center max-md:gap-4  items-center ">
        <div className=" flex flex-col justify-center items-center">
          <img className="w-screen  md:h-[85vh] object-fill" alt="cohesive mind banner" src={require("../../assets/cohesive-minds/cohesive-banner.jpg")} />
        </div>
      </div>
        
        <div className="my-6 md:w-[40%] max-md:w-[70%] md:mt-[-60px] max-md:mx-auto relative flex justify-between">
          <button
            onClick={() => navigate("/purchase")}
            className={
              "btn text-sm md:text-lg font-semibold md:px-8 text-white bg-[#FF820F] hover:bg-[#FF820F]   no-underline rounded-full border-0 min-h-0 h-10  max-md:w-35 capitalize"
            }
          >
            Join Us
          </button>
          <button
            onClick={handlescroll}
            className={
              "btn btn-outline text-sm md:text-lg md:px-8 border-white bg-white max-md:bg-[#000] font-semibold text-[#FF820F] no-underline border-solid  hover:bg-black hover:text-white rounded-full min-h-0 h-10 max-md:w-[50%] whitespace-nowrap  capitalize"
            }
          >
            Take a free test
          </button>
          <div className="relative max-md:hidden">
            <Notification isMobile={false}/>
          </div>
        </div>
        <div className="absolute md:w-[25rem]  top-16 right-[5.7rem] max-md:left-0 ">
          {isPopupOpen && (
            <ExamInfo onClose={handleCloseExamInfo} />
          )}
        </div>

      </div>

  );
};

export default Banner;